import React, { useState } from 'react';
import { Table as MuiTable } from '@material-ui/core';
import Search from 'components/Search';
import { Paging } from 'components';

const Table = (props) => {
  const {
    model,
    columnsWidth,
    pagination,
    search = false,
    children,
    pagingProps = {},
    fitToParent = false,
    alignNoData,
    rowCount,
    ...rest
  } = props;
  let { columnCount, ...ref } = rest;
  const [page, setPage] = useState(0);
  const [keyword, setKeyword] = useState(null);
  const [name, setName] = useState(null);
  const [sorting, setSorting] = useState('ascending');

  if (!columnCount) {
    const tableHead = React.Children.toArray(children).find(item => item.type.name === 'TableHead');
    columnCount = tableHead
      ? React.Children.toArray(tableHead.props.children).reduce((prev, item) => prev + item.props.children.length, 0)
      : null;
  }

  const maxPage = Math.ceil(rowCount / pagination) - 1;

  const handleChangeName = (nameTable) => () => {
    if (name === nameTable) {
      if (sorting === 'ascending') {
        setSorting('descending')
      } else {
        setSorting('ascending')
      }
    } else {
      setSorting('ascending');
      setName(nameTable)
    }
  }

  return (
    <div style={{
      width: '100%',
      height: fitToParent ? 'calc(100% - 40px)' : 'unset',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between'
    }}>
      <div style={{ width: '100%' }}>
        {search &&
                    <Search
                      onChange={(keyword) => setKeyword(keyword)}
                      style={{
                        marginBottom: 15,
                        width: 200
                      }}
                    />
        }
        <MuiTable {...ref}>
          {columnsWidth && (
            <colgroup>
              {columnsWidth.map((width, key) => <col width={width} key={key}/>)}
            </colgroup>
          )}
          {React.Children.toArray(children).map(child =>
            React.cloneElement(child, {
              model,
              pagination,
              columnCount,
              page,
              alignNoData,
              activeName: name,
              onNameChange: handleChangeName,
              sortType: sorting,
              ...(search && { keyword })
            })
          )}
        </MuiTable>
      </div>
      {typeof pagination === 'number' &&
                <Paging
                  page={page}
                  setPage={setPage}
                  maxPage={maxPage}
                  position='left'
                  type='full'
                  withoutFirstLast={false}
                  {...pagingProps}
                />
      }
    </div>
  )
}

export default Table;
